/** Left-nav background themes shared by Cloud Office and tenant portal. */
export const SIDEBAR_THEME_OPTIONS = [
  { id: "none", label: "None" },
  { id: "blue", label: "Blue" },
  { id: "dark", label: "Dark" },
];

const SCOPE_THEME_OPTIONS = {
  office: SIDEBAR_THEME_OPTIONS,
  portal: [
    { id: "none", label: "None" },
    { id: "sage", label: "Sage" },
    { id: "dark", label: "Dark" },
  ],
};

/** Retired portal themes; map old saved values forward. */
const SCOPE_THEME_ALIASES = {
  portal: { blue: "sage", mist: "sage" },
};

const STORAGE_KEYS = {
  office: "cloudOfficeSidebarTheme",
  portal: "cportal_sidebar_theme",
};

const DEFAULTS = {
  office: "none",
  portal: "sage",
};

export function getSidebarThemeOptions(scope) {
  return SCOPE_THEME_OPTIONS[scope] || SIDEBAR_THEME_OPTIONS;
}

export function normalizeSidebarTheme(value, scope) {
  let v = String(value || "").trim().toLowerCase();
  const alias = SCOPE_THEME_ALIASES[scope]?.[v];
  if (alias) v = alias;
  const options = scope ? getSidebarThemeOptions(scope) : [
    ...SIDEBAR_THEME_OPTIONS,
    ...SCOPE_THEME_OPTIONS.portal,
  ];
  return options.some((o) => o.id === v) ? v : null;
}

export function getSidebarThemeDefault(scope) {
  return DEFAULTS[scope] || "none";
}

export function getSidebarTheme(scope) {
  const key = STORAGE_KEYS[scope];
  if (!key) return getSidebarThemeDefault(scope);
  try {
    const stored = normalizeSidebarTheme(localStorage.getItem(key), scope);
    if (stored) return stored;
  } catch {
    /* ignore */
  }
  return getSidebarThemeDefault(scope);
}

export function setSidebarTheme(scope, theme) {
  const next = normalizeSidebarTheme(theme, scope) || getSidebarThemeDefault(scope);
  const key = STORAGE_KEYS[scope];
  if (!key) return next;
  try {
    localStorage.setItem(key, next);
  } catch {
    /* ignore */
  }
  try {
    window.dispatchEvent(
      new CustomEvent("sidebarThemeChanged", { detail: { scope, theme: next } })
    );
  } catch {
    /* ignore */
  }
  return next;
}

export function sidebarThemeClassName(theme) {
  const t = normalizeSidebarTheme(theme) || "none";
  return `sidebar-theme-${t}`;
}
